/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Critical_LabelInputs */

const tr_mesafeli_s12_critical_label = /** @type {(inputs: Mesafeli_S12_Critical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritik olay yanıtı:`)
};

const en_mesafeli_s12_critical_label = /** @type {(inputs: Mesafeli_S12_Critical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critical incident response:`)
};

const de_mesafeli_s12_critical_label = /** @type {(inputs: Mesafeli_S12_Critical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktion auf kritische Vorfälle:`)
};

const ru_mesafeli_s12_critical_label = /** @type {(inputs: Mesafeli_S12_Critical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реакция на критический инцидент:`)
};

/**
* | output |
* | --- |
* | "Critical incident response:" |
*
* @param {Mesafeli_S12_Critical_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_critical_label = /** @type {((inputs?: Mesafeli_S12_Critical_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Critical_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_critical_label(inputs)
	if (locale === "de") return de_mesafeli_s12_critical_label(inputs)
	if (locale === "ru") return ru_mesafeli_s12_critical_label(inputs)
	return tr_mesafeli_s12_critical_label(inputs)
});